import axios from 'axios';

import { INGRESOS } from './types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

export const filtrarIngresos = (opcion) => dispatch => {
    dispatch({
        type: INGRESOS.FILTROS,
        payload: opcion
    });
}

export const buscarIngresos = (filtros) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(filtros);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ingresos/listar`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: INGRESOS.BUSCAR,
            payload: res.data.ingresos
        });
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const obtenerIngreso = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = {
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ingresos/detalles`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: INGRESOS.DETALLES,
            payload: res.data.ingreso
        });
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const limpiarIngreso = () => dispatch => {
    dispatch({
        type: INGRESOS.DETALLES,
        payload: null
    });
}

export const crearIngreso = (ingreso) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(ingreso);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ingresos/crear`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: INGRESOS.AGREGAR,
            payload: res.data.ingreso
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const editarIngreso = (ingreso) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(ingreso);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ingresos/editar`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: INGRESOS.EDITAR,
            payload: res.data.ingreso
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const eliminarIngreso = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = {
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ingresos/eliminar`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: INGRESOS.ELIMINAR,
            payload: id
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}